import { DomainRuleError } from "./core";

export const patientFlowStages = [
  "waiting",
  "pre_test",
  "testing",
  "post_test",
  "on_hold",
] as const;

export type PatientFlowStage = (typeof patientFlowStages)[number];

export const patientFlowStageLabels: Readonly<Record<PatientFlowStage, string>> = {
  waiting: "대기",
  pre_test: "검사 전",
  testing: "검사 중",
  post_test: "검사 후",
  on_hold: "보류",
};

export function isPatientFlowStage(value: unknown): value is PatientFlowStage {
  return patientFlowStages.some((stage) => stage === value);
}

const transitions: Readonly<
  Record<PatientFlowStage, readonly PatientFlowStage[]>
> = {
  waiting: ["pre_test", "testing", "on_hold"],
  pre_test: ["waiting", "testing", "on_hold"],
  testing: ["post_test", "on_hold"],
  post_test: ["waiting", "pre_test", "on_hold"],
  on_hold: ["waiting", "pre_test", "testing", "post_test"],
};

export function assertPatientFlowTransition(
  current: PatientFlowStage,
  next: PatientFlowStage,
): void {
  if (!transitions[current].includes(next)) {
    throw new DomainRuleError(
      "INVALID_PATIENT_FLOW_TRANSITION",
      `환자 흐름을 ${patientFlowStageLabels[current]}에서 ${patientFlowStageLabels[next]}(으)로 변경할 수 없습니다.`,
    );
  }
}

export function emptyPatientFlowCounts(): Record<PatientFlowStage, number> {
  return {
    waiting: 0,
    pre_test: 0,
    testing: 0,
    post_test: 0,
    on_hold: 0,
  };
}
